const jQuery = require('jquery');
global.jQuery = jQuery;
require('jquery-ui-bundle');